import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "shared/components/button/CustomButton";
import BodyPanel from "shared/components/panel/BodyPanel";
import FooterPanel from "shared/components/panel/FooterPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import { Panel } from "shared/components/panel/Panel";
import DetalhesDoProcesso from "./DetalhesDoProcesso";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "context/UserContext";
import CustomAccordion from "shared/components/accordion/CustomAccordion";
import { CustomAccordionItem } from "types/accordion/CustomAccordionItemType";
import AnexarDocumentosProcessosJudiciais from "./AnexarDocumentosProcessosJudiciais";
import { Fade } from "@mui/material";
import { useGetEditarVisualizarProcessoJudicial } from "hooks/processosJudiciais/useGetEditarVisualizarProcessoJudicial";
import { queryClient } from "shared/util/queryClient";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import ModalSelecionarCobrancas from "./ModalSelecionarCobrancas";
import TabelaCobrancasVinculadasAoProcesso from "./TabelaCobrancasVinculadasAoProcesso";
import { Row } from "react-bootstrap";
import { useGetIdsCobrancasVinculadasAoProcesso } from "hooks/processosJudiciais/useGetIdsCobrancasVinculadasAoProcesso";
import usePostAlterarCondominioContextoToken from "hooks/condominio/usePostAlterarCondominioContextoToken";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";

export default function ProcessosJudiciais() {
  const [mostrarConteudo, setMostrarConteudo] = useState(false);
  const [deveBuscarIdsCobrancasDoProcesso, setDeveBuscarIdsCobrancasDoProcesso] = useState(false);

  const navigate = useNavigate();
  const { usuarioLogado } = useContext(UserContext);
  const location = useLocation();
  const { data: processoJudicial } = useGetEditarVisualizarProcessoJudicial(location.state?.processoJudicialId);
  const { iniciarAcordosV1 } = IntegracaoV1();
  const {} = useGetIdsCobrancasVinculadasAoProcesso({
    processoJudicialId: location.state?.processoJudicialId,
    deveBuscarIdsCobrancasDoProcesso: deveBuscarIdsCobrancasDoProcesso,
    condominioId: processoJudicial?.condominioId,
  });
  const { alterarCondominioContextoToken } = usePostAlterarCondominioContextoToken();

  const {
    isVisualizacao,
    setIsVisualizacao,
    setIsEdicao,
    openCloseModalSelecionarCobrancas,
    setUnidadeId,
    idsCobrancasVinculadasAoProcessoSelecionadas,
    opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso,
    processoPossuiCobrancasVinculadas,
    possuiPermissaoIniciarAcordo,
  } = useProcessosJudiciaisContext();

  useEffect(() => {
    if (location && location.state) {
      setIsVisualizacao(location.state.isVisualizacao);
      setIsEdicao(location.state.isEdicao);
      setUnidadeId(location.state.unidadeId);
    }
    setMostrarConteudo(true);
  }, []);

  const itensAccordionAnexarDocumentos: CustomAccordionItem[] = [
    {
      key: "anexar-documentos",
      titulo: "Anexar documentos",
      conteudo: <AnexarDocumentosProcessosJudiciais processoJudicialId={processoJudicial?.id} />,
    },
  ];

  const conteudoAccordionCobrancasEmAberto = () => {
    return (
      <>
        <TabelaCobrancasVinculadasAoProcesso />
        {possuiPermissaoIniciarAcordo && (
          <Row className="mt-4">
            <div className="d-flex justify-content-end">
              <CustomButton
                id="btn-iniciar-acordo"
                label="Iniciar acordo"
                variant="outline-primary"
                disabled={
                  isVisualizacao ||
                  !processoPossuiCobrancasVinculadas ||
                  (idsCobrancasVinculadasAoProcessoSelecionadas.length === 0 &&
                    opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso !== "TODAS_FILTRO")
                }
                onClick={() => iniciarAcordos()}
              />
            </div>
          </Row>
        )}
      </>
    );
  };

  const itensAccordionCobrancasEmAberto: CustomAccordionItem[] = [
    {
      key: "cobrancas-em-aberto",
      titulo: "Cobranças em aberto",
      conteudo: conteudoAccordionCobrancasEmAberto(),
      botoes: isVisualizacao
        ? []
        : [
            <CustomButton
              key={"btnAdicionarCobranca"}
              variant="primary"
              id="btnAdicionarCobranca"
              label="Adicionar cobrança"
              size="sm"
              disabled={isVisualizacao}
              onClick={(e) => {
                e.stopPropagation();
                openCloseModalSelecionarCobrancas();
              }}
            />,
          ],
    },
  ];

  const iniciarAcordos = async () => {
    if (opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso === "TODAS_FILTRO") {
      setDeveBuscarIdsCobrancasDoProcesso(true);
    } else {
      await alterarCondominioContextoToken(processoJudicial.condominioId);
      iniciarAcordosV1(idsCobrancasVinculadasAoProcessoSelecionadas);
    }
  };

  return (
    <Fade in={mostrarConteudo} timeout={700}>
      <div>
        <Panel
          headerPanel={
            <HeaderPanel title="Processos judiciais" ocultarCondominio={!usuarioLogado.condominioContextoId} />
          }
          footerPanel={
            <FooterPanel
              title="FooterPanel"
              botoes={[
                <CustomButton
                  key={"btnVoltar"}
                  variant="danger-alt"
                  id="btnVoltar"
                  label="Voltar"
                  size="sm"
                  className="footer-panel-btn"
                  onClick={() => {
                    queryClient.invalidateQueries(["processos-judiciais"]);
                    navigate(-1);
                  }}
                />,
              ]}
            />
          }
        >
          <BodyPanel>
            <DetalhesDoProcesso
              key={"detalhes-processo"}
              unidadeId={processoJudicial?.unidadeId}
              processoId={processoJudicial?.id}
              isVisualizacao={isVisualizacao}
              processsoJudicial={processoJudicial}
            />
            <CustomAccordion keyItemAtivoPorPadrao="anexar-documentos" itens={itensAccordionAnexarDocumentos} />
            <CustomAccordion
              alinharBotoesNaDireita
              keyItemAtivoPorPadrao="cobrancas-em-aberto"
              itens={itensAccordionCobrancasEmAberto}
            />
            <ModalSelecionarCobrancas />
          </BodyPanel>
        </Panel>
      </div>
    </Fade>
  );
}
